
import {Component, Prop, Mixins} from 'vue-property-decorator';
import ObjectInputMixin from '@/mixins/ObjectInputMixin.vue';
import TarafKisi from '@/plugins/uyap-plugin/takip_ac/parser/TarafKisi';
import TarafKurum from '@/plugins/uyap-plugin/takip_ac/parser/TarafKurum';
import TarafBadges from './TarafBadges.vue';

@Component({
  components: {
    TarafBadges,
  },
})
export default class TarafColumn extends Mixins(ObjectInputMixin) {
  @Prop({required: true}) readonly tarafList!: Array<TarafKisi | TarafKurum>;
  @Prop({required: true}) readonly type!: 'alacakli' | 'borclu';
  @Prop({default: false}) readonly disabled!: boolean;
  @Prop({default: false}) isReadonly!: boolean;

  isTarafDisabled(taraf: TarafKisi | TarafKurum): boolean {
    if (this.disabled)
      return true;
    else
      return !taraf.takipeDahilEt;

  }

  // Tarafın seçim durumunu değiştir
  setTarafSelected(taraf: TarafKisi | TarafKurum, selected: boolean): void {
    this.$set(this.localValue, taraf.refId, selected);
    // ObjectInputMixin'in input() metodu otomatik emit ve $forceUpdate yapıyor
    this.input();
  }

  getXmlTarafName(taraf: TarafKisi | TarafKurum): string {
    if (taraf.kisiMi)
      return taraf.adSoyad;
    else
      return taraf.kurumAdi;
  }

  isNameMismatch(taraf: TarafKisi | TarafKurum): boolean {
    // Sadece kişiler için kontrol yap
    if (!taraf.kisiMi) return false;
    
    // Sorgulanmış isim yoksa kontrol yapma
    if (!taraf.temelBilgileri?.adi || !taraf.temelBilgileri?.soyadi) return false;
    
    const xmlName = this.getXmlTarafName(taraf); // adSoyad
    const queriedName = taraf.getIsim(); // adi + soyadi
    
    // matchMaskedValue ile karşılaştır
    return !this.matchMaskedValue(xmlName, queriedName);
  }

  getTarafNameStyle(taraf: TarafKisi | TarafKurum): string {
    const hasError = this.isTarafDisabled(taraf);
    if (hasError) {
      if (this.disabled)
        return 'color: #64748b;';
      return 'color: #c62828; font-weight: 500;';
    }
    
    // İsim eşleşmeme durumunda warning rengi
    if (this.isNameMismatch(taraf)) {
      return 'color: #f59e0b; font-weight: 500;';
    }
    
    return 'color: #1f2937;';
  }

  matchMaskedValue(real: string, masked: string): boolean {
    const r = real.trim().toLocaleLowerCase('tr-TR').normalize('NFC');
    const m = masked.toLocaleLowerCase('tr-TR').normalize('NFC');

    if (r.length !== m.length) return false;

    for (let i = 0; i < r.length; i++) {
      if (m[i] === '*') continue;
      if (r[i] !== m[i]) return false;
    }

    return true;
  }
}
